"use client";

import dynamic from "next/dynamic";

export const MapboxMarkerPopup = dynamic(() =>
	import("./Marker").then((mod) => mod.MapboxMarkerPopup),
);
export const MapboxMarkerRoot = dynamic(() =>
	import("./Marker").then((mod) => mod.MapboxMarkerRoot),
);
export const MapboxMarkerTrigger = dynamic(() =>
	import("./Marker").then((mod) => mod.MapboxMarkerTrigger),
);

export const MapboxRoot = dynamic(() => import("./Mapbox").then((mod) => mod.MapboxRoot));
